<template>
  <div>
    <div class="text-right pb-5">
      <v-btn
          class="br-8 border-w-2 mr-2"
          color="primary"
          outlined
          @click="$router.push({ name: 'dispatch-history' })"
      >
        <b>{{ $lang.VIEW_DISPATCH_HISTORY }}</b>
      </v-btn>

      <v-btn
          :disabled="shipment_id_list.length > 0 ? false : true"
          :loading="btn_loading"
          color="primary"
          width="100"
          @click="OpenDiliveryAgentDialog"
      >
        <b>{{ $lang.DISPATCH }} </b>
      </v-btn>
      <v-btn
          class="ml-2"
          color="primary"
          text
          width="100"
          @click="getDispatchList2"
      >
        <v-icon>mdi-autorenew</v-icon>
        <b>{{ $lang.REFRESH }}</b>
      </v-btn>
    </div>
    <!-- shipment List -->
    <div>
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :hide-default-footer="true"
          :items="dispatch_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          :single-select="singleSelect"
          class="elevation-1 custome-header-bg custome-table-body"
          item-key="line_id"
          show-expand
          show-select
          single-expand
          @item-expanded="loadShipments"
      >
        <template v-slot:item.data-table-select="{ item }">
          <v-checkbox
              v-model="item.is_all_selected"
              @click="selectLineshipments(item)"
          ></v-checkbox>
        </template>
        <!-- <template v-slot:item.shipment_count="{ item }"> -->
        <!-- <p>{{ item.shipment_list.length }}</p> -->
        <!-- </template> -->

        <template v-slot:expanded-item="{ headers }">
          <td
              :colspan="headers.length"
              class="pa-0 ma-0"
              style="height: auto !important"
          >
            <!-- loader -->
            <div v-if="shipment_list.length<1" class="text-center py-10 bg-transparent blue-grey lighten-5">
              <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
              ></v-progress-circular>
            </div>
            <v-simple-table v-if="shipment_list.length>0" class="blue-grey lighten-5 inner-table" dense>
              <template v-slot:default>
                <tr class="pa-2 border-b">
                  <th class="text-left pl-3 pt-2"></th>
                  <th class="text-left pl-3 pt-2">{{ $lang.SHIPMENT_ID }}</th>
                  <th class="text-left pl-3 pt-2">{{ $lang.DROPED_AT }}</th>
                  <th class="text-left">{{ $lang.RETAILER_INFO }}</th>
                  <th class="text-left">{{ $lang.CHALLAN_NUMBER }}</th>
                  <th class="text-left">{{ $lang.AMOUNT }}</th>
                  <th class="text-left">{{ $lang.MODE }}</th>
                  <th class="text-center">{{ $lang.STATUS }}</th>
                  <th class="text-left">{{ $lang.WHOLESALER_INFO }}</th>
                </tr>
                <tr
                    v-for="shipment in shipment_list"
                    :key="shipment.shipment_id"
                    class="border-b"
                >
                  <td class="text-left pl-3">
                    <v-checkbox
                        v-model="shipment_id_list"
                        :value="shipment.shipment_id"
                        @change="on_change_event(shipment)"
                    ></v-checkbox>
                  </td>
                  <td class="text-left pl-3">{{ shipment.shipment_id }}</td>
                  <td class="text-left pl-3">
                    <p>{{ shipment.drop_time }}</p>
                    <p>{{ shipment.drop_date }}</p>
                  </td>
                  <td class="text-left pt-2">
                    <p>{{ shipment.retailer_firm_name }}</p>
                    <p>{{ shipment.retailer_mobile_number }}</p>
                    <p>({{ shipment.retailer_location }})</p>
                  </td>
                  <td class="pt-2">
                    <p>{{ shipment.challan_number }}</p>
                  </td>
                  <td class="pt-2">
                    <!-- <p
                    v-if="
                    shipment.final_status == $keys.RETURN ||
                    shipment.final_status == $keys.PARTIAL_RETURN
                    "
                    >
                    0.00
                  </p> -->
                    <p>{{ shipment.shipment_amount }}</p>
                  </td>
                  <td class="pt-2">
                    <p>{{ shipment.payment_mode }}</p>
                  </td>
                  <td class="text-center">
          <span
              v-if="shipment.final_status"
              :class="getClassSatus(shipment.final_status)"
          >{{ shipment.final_status }}</span
          >
                    <span
                        v-if="!shipment.final_status"
                        :class="getClassSatus($lang.IN_TRANSIT)"
                    >{{ $lang.IN_TRANSIT }}</span
                    >
                  </td>

                  <td class="pt-2">
                    <p>{{ shipment.wholesaler_firm_name }}</p>
                    <p>{{ shipment.wholesaler_mobile_number }}</p>
                  </td>
                </tr>
              </template>
            </v-simple-table>
          </td>
        </template>

        <!--empty state  -->
        <template v-slot:no-data>
          <empty-list :message="$lang.EMPTY_SHIPMENTS"/>
        </template>
      </v-data-table>
    </div>

    <v-pagination
        v-model="page_number"
        :length="total_page_count"
        :total-visible="7"
        class="custome-pagination"
        @input="getDispatchList"
    ></v-pagination>

    <assign-delivery-agent-dialog
        ref="assign_delivery_agent_elm"
        :dialog="dialog"
        :shipment_id_list="shipment_id_list"
        :shipment_line_list="shipment_line_list"
        :total_packets="shipment_id_list.length"
        @update-data="refreshData"
    />
  </div>
</template>
<script>
export default {
  components: {
    AssignDeliveryAgentDialog: () =>
        import("./child/AssignDeliveryAgentDialog.vue"),
  },
  data() {
    return {
      dialog: {
        flag: false,
      },
      dispatch_list: [],
      shipment_line_list: [],
      shipment_id_list: [],
      shipment_list: [],
      selected: [],
      total_packets: 0,
      btn_loading: false,
      line_id: null,

      /* table data */
      page_number: 1,
      total_page_count: 1,
      singleSelect: true,
      table_loading: false,
      headers: [
        {text: "Line", value: "line_name"},
        {
          text: "Number of shipment",
          value: "shipment_count",
          align: "center",
        },
        {text: "", value: "data-table-expand"},
      ],
    };
  },
  /* terminating the  polling  on rout leave*/
  beforeRouteLeave(to, from, next) {
    let url =
        this.$urls.BASE_URL +
        this.$urls.GET_DISPATCH_LIST +
        "?page_number=" +
        this.page_number +
        "&page_length=" +
        this.$keys.PAGE_LENGTH;
    this.$polling.removeObserver(url);
    delete this.$options.listeners[url];
    next();
  },
  created() {
    this.$store.dispatch("setPageLoader", true);
    self.table_loading = true;
    this.getDispatchList2();
    this.getDispatchList();
    this.$store.dispatch("drawer/setActiveTab", -1);
  },
  methods: {
    /*on click event on the shipment check */
    on_change_event(shipment) {
      if (this.shipment_id_list.includes(shipment.shipment_id))
        this.shipment_line_list.push(shipment.line_name)
      else
        this.shipment_line_list.splice(this.shipment_line_list.indexOf(shipment.line_name), 1);
    },
    refreshData() {
      this.getDispatchList2()
      this.loadShipments()
    },
    /* get shipmen list line voice  with pollling*/
    getDispatchList() {
      this.shipment_id_list = [];
      const self = this;
      let url =
          this.$urls.BASE_URL +
          this.$urls.GET_DISPATCH_LIST +
          "?page_number=" +
          this.page_number +
          "&page_length=" +
          this.$keys.PAGE_LENGTH;
      let warehouse_id = "";
      if (self.$store.state.warehouse)
        warehouse_id = self.$store.state.warehouse.id;
      this.$polling.addObserver(url, {
        interval: this.$store.state.polling_interval,
        maxFails: 10,
        headers: {
          token: sessionStorage.getItem("token"),
          "warehouse-id": warehouse_id,
          "application-type": "web",
        },
      });
      this.$options.listeners[url] = (response) => {
        this.$store.dispatch("setPageLoader", false);
        self.table_loading = false;
        if (response.data.success) {
          this.dispatch_list = response.data.line_list;
          this.dispatch_list.map(function (entry) {
            entry.is_all_selected = false;
            return entry;
          });
        }
      };
    },
    /* for instant refresh */
    getDispatchList2() {
      const self = this;
      self.table_loading = true;
      self.shipment_id_list = [];
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
      };
      const successHandler = (response) => {
        console.log(response);
        if (response.data.success) {
          this.dispatch_list = response.data.line_list;
          this.dispatch_list.map(function (entry) {
            entry.is_all_selected = false;
            return entry;
          });
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
          self,
          self.$urls.GET_DISPATCH_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
    /* loading the shipment data for the expanded row */
    loadShipments(obj) {
      this.shipment_list = []

      let line_id = null
      if (!obj)
        line_id = this.line_id
      else
        line_id = obj.item.id
      this.line_id = line_id

      const self = this;
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        line_id: line_id,
      };
      const successHandler = (response) => {
        console.log(response);
        if (response.data.success) {
          this.shipment_list = response.data.shipment_list;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        this.$store.dispatch("setPageLoader", false);
      };

      self.request_GET(
          self,
          self.$urls.GET_DISPATCH_LIST,
          params,
          successHandler,
          null,
          null,
          finallyHandler
      );
    },
    /*  select the  shipemnt form selected line */
    selectLineshipments(item) {
      console.log(item)
      if (item.is_all_selected) {

        for (let i = 0; i < item.shipment_id_list.length; i++) {
          this.shipment_id_list.push(item.shipment_id_list[i][0]);
          this.shipment_line_list.push(item.line_name)
        }
      } else {
        this.shipment_line_list = this.shipment_line_list.filter(a => a !== item.line_name)
        for (let i = 0; i < item.shipment_id_list.length; i++) {
          let index = this.shipment_id_list.indexOf(
              item.shipment_id_list[i][0]
          );
          if (index > -1) {
            this.shipment_id_list.splice(index, 1);
          }
        }
      }

      this.shipment_id_list = [...new Set(this.shipment_id_list)];

      item.is_all_selected = !item.is_all_selected;
    },
    /* open the dialog box to select the deluvery agent */
    OpenDiliveryAgentDialog() {
      this.dialog.flag = true;
      this.shipment_line_list = [...new Set(this.shipment_line_list)];
      this.$refs.assign_delivery_agent_elm.delivery_agent_id_list = [];
      this.$refs.assign_delivery_agent_elm.getDeliveryAgents();
    },
  },
};
</script>